export enum ErrorCodes {
  AUTH_EXPIRED = 5001,
  ROOM_ACCESS_DENIED,
  ROOM_DELETED,
  TEAM_MEMBER_REMOVED = 5006,
}

export enum CanvasErrorCodes {
  LOGIN_EXPIRED = 10022, // 用户未登录或登录态失效
  ROOM_ACCESS_NOT_MATCH = 11105, // 用户当前登录态与roomid不符
  FAST_REQUEST = 11106, // 创建任务频率过高，失败；3s
  SAFE_AUDIT_FAILED = 11107, // 算法安审拦截提示
  DEFAULT_ERROR = 5003,
  SHARE_CLOSE = 11002, // 节点事件流分享被关闭
  COMMUNITY_NOT_PUBLISH = 11019, // 社区案例未发布无数据
  COMMUNITY_NOT_PASSED = 11020, // 社区案例未通过审核
  TEAM_SUB_GROUP_MISSING = 15240, // 团队订阅分组初始化失败
  TEAM_MEMBER_REMOVED = 21003, // 团队态 WebAPI：当前成员已被移出团队
}
